import { useEffect, useState } from "react";
import { ArrowsClockwise } from "@phosphor-icons/react";

function timeAgo(ts) {
  if (!ts) return "—";
  const diff = Math.floor((Date.now() - ts) / 1000);
  if (diff < 5) return "just now";
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  return `${Math.floor(diff / 3600)}h ago`;
}

export default function RefreshButton({ lastUpdated, loading, onRefresh }) {
  const [, force] = useState(0);

  // tick every 10s to keep "X seconds ago" fresh
  useEffect(() => {
    const t = setInterval(() => force(x => x + 1), 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <button
      data-testid="refresh-button"
      onClick={onRefresh}
      disabled={loading}
      className="flex items-center gap-2 border border-zinc-800 hover:border-zinc-700 px-2.5 py-1 text-xs font-mono text-zinc-300 transition-colors disabled:opacity-60"
      title="Refresh data"
    >
      <ArrowsClockwise size={12} className={`text-zinc-500 ${loading ? "animate-spin" : ""}`} />
      <span className="text-zinc-500">Updated</span>
      <span className="text-zinc-300">{timeAgo(lastUpdated)}</span>
    </button>
  );
}
